import React from "react";
import { Link } from "react-router-dom";
import Github from "../images/Github.svg";
import mail from "../images/Email.svg";
import linkdln from "../images/Linkedin.svg";

const FooterDesktop = () => {
  return (
    <>
      <div
        style={{
          borderTop: "2px solid #ABB2BF",
          width: "100%",
          marginTop: "5%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "76%",
            margin: "0 auto",
            padding: "3% 0",
          }}
        >
          <div>
            <h2 style={{ color: "white", fontWeight: "bolder" }}>Mayowa</h2>
            <h4 style={{ color: "white", fontWeight: "bolder" }}>
              Blockchain and Full Stack-Developer
            </h4>
          </div>
          <div>
            <h3 style={{ color: "white", fontWeight: "bolder" }}>Media</h3>
            <div style={{ display: "flex", color: "#ABB2BF", gap: "3%" }}>
              <Link to="https://github.com/shazzar-ox">
                <img src={Github} alt="" />
              </Link>
              <Link to="mailto: emmanuelmayowa95@gmail.com">
                <img src={mail} alt="" />
              </Link>
              <Link to="https://www.linkedin.com/in/mayowa-abikoye">
                <img src={linkdln} alt="" />
              </Link>
            </div>
          </div>
        </div>
        <p style={{ textAlign: "center", color: "#ABB2BF" }}>
          copyright 2023 made by Mayowa
        </p>
      </div>
    </>
  );
};

export default FooterDesktop;
